import { gql } from '@apollo/client';

export const DASHBOARD_GET_ALL_PRODUCT_APPS = gql`
  query GetAllProductApps(
    $personId: ID!
    $types: [ApplicationTypeEnum]
    $subTypes: [ApplicationSubTypeEnum]
  ) {
    getAllProductApps(personId: $personId, types: $types, subTypes: $subTypes) {
      id
      type
      subType
    }
  }
`;

export default DASHBOARD_GET_ALL_PRODUCT_APPS;
